/* AROMERIA mobile menu - reliable open/close (global via theme.liquid <head>).
   Horizon's drawer fought us at three cascade layers on mobile:
   1) `.menu-open` class did not land on real taps;
   2) panel transform: CSS TRANSITIONS outrank inline !important -> killed with transition:none;
   3) menu LINKS: staggered entrance ANIMATION `menu-drawer-nav-open` (animation-fill-mode:backwards)
      left the anchors at the 0% keyframe (hidden/opacity 0) -> unclickable.
   Takeover: window+capture (before Horizon), re-entry guard. Force panel AND link state with
   inline !important, and kill transition+animation so nothing in the theme cascade can hold the
   hidden/closed value. No entrance animation (launch > anim). Only touches .menu-drawer*.
   FIX 2026-06-29: open/close decision uses OUR OWN flag `data-ar-open`, not d.open. A Horizon
   pointerdown/native toggle race (e.g. first burger tap right after closing the cart drawer)
   could flip d.open before our click handler ran, so a toggle keyed on d.open chose "close" and
   ate the first tap. openMenu is idempotent and force-opens regardless, so a stray tap can only
   ever leave the menu OPEN, never stuck closed. */
(function () {
  function panel(d) { return d.querySelector('.menu-drawer'); }
  function setExpanded(d, v) { var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', v ? 'true' : 'false'); }
  function force(el, kv) { for (var k in kv) el.style.setProperty(k, kv[k], 'important'); }
  function revealLinks(p) {
    p.querySelectorAll('.menu-drawer__animated-element').forEach(function (el) {
      if (el.closest('.menu-drawer__submenu')) return;
      force(el, { animation: 'none', transition: 'none', visibility: 'visible', opacity: '1', transform: 'none' });
    });
    p.querySelectorAll(':scope > .menu-drawer__navigation a[href], :scope > .menu-drawer__navigation .menu-drawer__menu-item, :scope > .menu-drawer__navigation .menu-drawer__menu-item-text').forEach(function (el) {
      if (el.closest('.menu-drawer__submenu')) return;
      force(el, { visibility: 'visible', opacity: '1' });
    });
  }
  function openMenu(d) {
    var p = panel(d);
    d.open = true;
    d.setAttribute('data-ar-open', '1');
    d.classList.add('menu-open');
    setExpanded(d, true);
    if (p) {
      force(p, { transition: 'none', display: 'flex', visibility: 'visible', opacity: '1', transform: 'translateX(0)' });
      revealLinks(p);
    }
    document.documentElement.setAttribute('scroll-lock', '');
  }
  function closeMenu(d) {
    var p = panel(d);
    d.classList.remove('menu-open');
    d.setAttribute('data-ar-open', '0');
    setExpanded(d, false);
    d.open = false;
    if (p) force(p, { transition: 'none', transform: 'translateX(-100%)', opacity: '0', visibility: 'hidden' });
    if (!document.querySelector('.menu-drawer-container[open]')) document.documentElement.removeAttribute('scroll-lock');
  }
  var lock = false;
  function act(d) {
    if (lock) return;
    lock = true; setTimeout(function () { lock = false; }, 80);
    if (d.getAttribute('data-ar-open') === '1') closeMenu(d); else openMenu(d);
  }
  function burger(t) { return (t && t.closest) ? t.closest('summary.header__icon--menu, .menu-drawer-container > summary') : null; }
  function closer(t) { return (t && t.closest) ? t.closest('.menu-drawer__backdrop, .menu-drawer__close-button') : null; }
  window.addEventListener('click', function (e) {
    var b = burger(e.target);
    if (b) {
      var d = b.closest('details.menu-drawer-container');
      if (!d) return;
      e.preventDefault(); e.stopImmediatePropagation();
      act(d);
      return;
    }
    var c = closer(e.target);
    if (c) {
      var d2 = c.closest('details.menu-drawer-container');
      if (!d2) return;
      e.preventDefault(); e.stopImmediatePropagation();
      closeMenu(d2);
    }
  }, true);
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('details.menu-drawer-container[open]');
    if (d) { e.stopImmediatePropagation(); closeMenu(d); }
  }, true);
  function initFlags() {
    document.querySelectorAll('details.menu-drawer-container').forEach(function (d) {
      if (!d.hasAttribute('data-ar-open')) d.setAttribute('data-ar-open', d.open ? '1' : '0');
    });
  }
  if (document.readyState !== 'loading') initFlags(); else document.addEventListener('DOMContentLoaded', initFlags);
})();
